// removed by extract-text-webpack-plugin
module.exports = {"Shell":"Shell__3TFLd","ShellInstagram":"ShellInstagram__1jwZX","ShellBody":"ShellBody__3aNRl","BodyWrapper":"BodyWrapper__2e6tU","BodyScrollbar":"BodyScrollbar__1JCiv"};


//////////////////
// WEBPACK FOOTER
// ./routes/style.scss
// module id = r7nU
// module chunks = 0